var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrintSdk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240 176.525V79.4753C240 69.9058 234.872 61.0699 226.564 56.3221L141.23 7.56023C133.032 2.87554 122.968 2.87554 114.77 7.56023L29.4363 56.3221C21.1276 61.0699 16 69.9058 16 79.4753V176.525C16 186.094 21.1276 194.93 29.4363 199.678L114.77 248.44C122.968 253.125 133.032 253.125 141.23 248.44L226.564 199.678C234.872 194.93 240 186.094 240 176.525Z",
    fill: "#563EE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5201 103.559C81.5201 92.1455 90.7729 82.8927 102.187 82.8927H150.997V92.2261H102.187C95.9276 92.2261 90.8535 97.3002 90.8535 103.559V131.191H81.5201V103.559Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1509 113.357C67.9676 111.529 70.9224 111.52 72.7505 113.337L86.1863 126.689L99.6221 113.337C101.45 111.52 104.405 111.529 106.222 113.357C108.038 115.185 108.029 118.14 106.201 119.957L89.4758 136.578C87.6558 138.387 84.7168 138.387 82.8968 136.578L66.1714 119.957C64.3433 118.14 64.3341 115.185 66.1509 113.357Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.479 154.667C174.479 166.08 165.226 175.333 153.813 175.333H105.002V166H153.813C160.072 166 165.146 160.926 165.146 154.667V127.035H174.479V154.667Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.849 144.869C188.032 146.697 185.077 146.706 183.249 144.889L169.813 131.537L156.377 144.889C154.549 146.706 151.594 146.697 149.778 144.869C147.961 143.041 147.97 140.086 149.798 138.269L166.524 121.648C168.344 119.839 171.283 119.839 173.103 121.648L189.828 138.269C191.656 140.086 191.665 143.041 189.849 144.869Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.72 87.5594C190.72 99.0341 181.36 108.336 169.814 108.336C158.267 108.336 148.907 99.0341 148.907 87.5594C148.907 76.0847 158.267 66.7826 169.814 66.7826C181.36 66.7826 190.72 76.0847 190.72 87.5594Z",
    fill: "#9A8BF2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.814 99.0029C176.26 99.0029 181.387 93.8247 181.387 87.5594C181.387 81.2941 176.26 76.1159 169.814 76.1159C163.367 76.1159 158.24 81.2941 158.24 87.5594C158.24 93.8247 163.367 99.0029 169.814 99.0029ZM169.814 108.336C181.36 108.336 190.72 99.0341 190.72 87.5594C190.72 76.0847 181.36 66.7826 169.814 66.7826C158.267 66.7826 148.907 76.0847 148.907 87.5594C148.907 99.0341 158.267 108.336 169.814 108.336Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M107.093 170.667C107.093 182.141 97.733 191.443 86.1866 191.443C74.6401 191.443 65.2799 182.141 65.2799 170.667C65.2799 159.192 74.6401 149.89 86.1866 149.89C97.733 149.89 107.093 159.192 107.093 170.667Z",
    fill: "#9A8BF2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1866 182.11C92.6333 182.11 97.7599 176.932 97.7599 170.667C97.7599 164.401 92.6333 159.223 86.1866 159.223C79.7399 159.223 74.6132 164.401 74.6132 170.667C74.6132 176.932 79.7399 182.11 86.1866 182.11ZM86.1866 191.443C97.733 191.443 107.093 182.141 107.093 170.667C107.093 159.192 97.733 149.89 86.1866 149.89C74.6401 149.89 65.2799 159.192 65.2799 170.667C65.2799 182.141 74.6401 191.443 86.1866 191.443Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintSdk);
export default __webpack_public_path__ + "static/media/print_sdk.d73fc68967761a68bc075568c445e3ea.svg";
export { ForwardRef as ReactComponent };